import { Helmet } from 'react-helmet-async';

import CompactLayout from 'src/layouts/compact';

import { View500 } from 'src/sections/error';

// ----------------------------------------------------------------------

export default function SentryErrorPage() {
  return (
    <>
      <Helmet>
        <title> 500 Internal Server Error</title>
      </Helmet>

      <CompactLayout>
        <View500 />
      </CompactLayout>
    </>
  );
}
